import { Search } from 'iconoir-react';
import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { EmptyState } from '@savgroup-front-common/primitive/components/empty-state';
import { RESULT_TYPE } from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { AppBarSearchResultSection } from '../AppBarSearchResultSection/AppBarSearchResultSection';

import messages from './messages';

interface AppBarSearchResultsListProps {
  query?: string;
  isLoading: boolean;
  isFetchingMore: boolean;
  focusedResultType?: RESULT_TYPE;
  results: SearchResultList<ResultSearchType>[];
  onShowMore: (resultType: RESULT_TYPE) => void;
  onSelectResult: () => void;
}

export const AppBarSearchResultsList: FC<AppBarSearchResultsListProps> = ({
  query = '',
  isLoading,
  isFetchingMore,
  focusedResultType,
  results,
  onShowMore,
  onSelectResult,
}) => {
  const hasQuery = query.trim().length > 0;
  const visibleSections = results.filter((section) => !!section.hitCount);
  const hasResults = visibleSections.length > 0;

  return (
    <>
      {hasQuery && !isLoading && !hasResults && (
        <EmptyState
          icon={<Search />}
          title={safeFormattedIntlString(messages.noResults)}
          description={safeFormattedIntlString(messages.noResultsDescription)}
        />
      )}

      {hasResults && (
        <div className="flex flex-col gap-3">
          {visibleSections.map((section) => (
            <AppBarSearchResultSection
              key={section.type}
              section={section}
              isSectionLoading={
                isFetchingMore && focusedResultType === section.type
              }
              onShowMore={onShowMore}
              onSelectResult={onSelectResult}
            />
          ))}
        </div>
      )}
    </>
  );
};
